import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { checkMemoErrorMap } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { createControl } from '../../../utilities/formUtilities';
import { TextInputModel } from "../../../../shared/components/controls/text-input-control/TextInputModel";
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';

const controlName = 'checkMemo';
@Component({
  standalone: false,
  selector: 'mm-check-memo',
  templateUrl: './check-memo.component.html',
  styleUrls: ['./check-memo.component.scss']
})
export class CheckMemoComponent implements OnInit {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() shouldDisableFieldForEditQcd: boolean = false;
  checkMemoModel: TextInputModel = {
    controlName: 'checkMemo',
    label: 'Memo',
    hasGreyText: true,
    greyText: '(optional)',
    htmlMaxLength: 40
  };

  constructor() { }

  ngOnInit(): void {
    createControl(this.parentForm, controlName, '', [Validators.maxLength(Number(this.checkMemoModel.htmlMaxLength))]);
    if (this.shouldDisableFieldForEditQcd) {
      this.checkMemo?.disable();
    }
  }

  get checkMemoValidationError() {
    if (this.checkMemo && this.checkMemo.errors) {
      const errorKeys: string[] = Object.keys(this.checkMemo.errors ?? {});
      if (errorKeys.length > 0) {
        return checkMemoErrorMap[errorKeys[0] as keyof typeof checkMemoErrorMap];
      }
    }
  }

  get checkMemo(): FormControl<string> {
    return this.parentForm.get(this.checkMemoModel.controlName) as FormControl<string>;
  }

  get checkMemoLength(): number {
    return this.checkMemo?.value?.trim().length ?? 0;
  }

  get hasError(): boolean {
    return (this.checkMemo?.dirty && this.checkMemo?.invalid) ?? false;
  }

}
